import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { LoginService } from 'src/app/_clusters/services/login.service';
import { tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AuthState } from 'src/app/_store/reducers//auth.reducers';
import { Login } from 'src/app/_store/actions/auth.actions';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { AuthService } from 'projects/cma/src/app/pages/auth/auth-services/auth.service';
import { IndexdbServiceService } from 'projects/cma/src/app/clusters/services/indexdb-service.service';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AnimationOptions } from 'ngx-lottie';
import { GamePlanService } from 'src/app/_clusters/services/game-plan.service';

@Component({
  selector: 'app-lms-login',
  templateUrl: './lms-login.component.html',
  styleUrls: ['./lms-login.component.scss']
})
export class LmsLoginComponent implements OnInit {

  // constructor() { }

  // ngOnInit(): void {
  // }


   // particle
   particlesOptions = {
    particles: {
      lineLinked: {
        enable: true,
        color: 'random'
      },
      move: {
        enable: true,
        speed: 2
      }
    }
  };


  options: AnimationOptions = {
    path: '/assets/login.json',
  };

  styles: Partial<CSSStyleDeclaration> = {
    maxWidth: '500px',
    margin: '0 auto',
    display: 'block'
  };


  loginForm: UntypedFormGroup;
  errorMessage = '';
  showHidePass = 'fa-eye-slash';
  data: any;
  lms_type: any = '';
  isMobile: boolean = false;
  is_clicked: any = false;

  //  is welcome check variables
  userData: any
  isWelcome: any

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private dbService: IndexdbServiceService,
    private router: Router, private loginService: LoginService, private firestore: AngularFirestore,
    private deviceService: DeviceDetectorService, private gamePlanService: GamePlanService,
    private store: Store<AuthState>
  ) {

    this.lms_type = window.location.href;
    this.loginForm = this.formBuilder.group({
      registration_id: ['', [Validators.required, Validators.pattern(/^\S*$/)]],
      password: ['', [Validators.required, Validators.pattern(/^\S*$/)]],
      //  recaptcha: ['', Validators.required]
    });
  }

  ngOnInit() {  window.scroll({top:0,left:0,behavior:"smooth"});
    this.isMobile = this.deviceService.isMobile();
    localStorage.removeItem(environment.authTokenKey);
    localStorage.removeItem('mf_token');
    localStorage.removeItem('otb_id');
    localStorage.removeItem('enbsb');
    localStorage.removeItem('islogged_cma');
    localStorage.removeItem('islogged_cpa');
    localStorage.removeItem('is_mac_loggedin');
    this.dbService.deleteAll();


  }
  onSubmit() {
    // console.log(this.loginForm.value, 'in');

    this.is_clicked = true;
    if (this.loginForm.valid) {
      localStorage.clear();
      sessionStorage.clear();
      // for localhost
      if (this.lms_type.includes('4200')) {
        this.logincpa();
        // this.logincma();
      } else if (this.lms_type.includes('4300')) {
        this.logincma();
      }

      // for live or uat
      if (this.lms_type.includes('cpa')) {
        this.logincpa();
      } else if (this.lms_type.includes('cma')) {
        this.logincma();
      }
      // this.is_clicked = false;
      // for live or uat
      // if (this.lms_type.includes('cpa'))
      // {
      //   this.logincpa();
      // } else if (this.lms_type.includes('cma')) {
      //   this.logincma();
      // }

    } else {
      this.is_clicked = false;
      this.errorMessage = 'Username and Password are required';
    }
  }
  showHidePassword() {
    this.showHidePass === 'fa-eye-slash' ? this.showHidePass = 'fa-eye' : this.showHidePass = 'fa-eye-slash';
  }
  getUsers(id) {
    return new Promise<any>((resolve, _reject) => {
      this.firestore.collection('isLoggedIn').doc(id).snapshotChanges()
        .subscribe(snapshots => {
          resolve(snapshots);
        });
    });
  }

  getUserscma(id) {
    return new Promise<any>((resolve, _reject) => {
      this.firestore.collection('isLoggedIn_CMA').doc(id).snapshotChanges()
        .subscribe(snapshots => {
          resolve(snapshots);
        });
    });
  }

  logincpa() {
    this.loginService.login(this.loginForm.value.registration_id.trim(), this.loginForm.value.password.trim())
      .pipe(
        tap((user: any) => {
          if (user.status) {
            if (user.data[4].int_user_status === 1) {
              // console.log('user.data[4]--', user.data);
              this.store.dispatch(new Login({ authToken: user['data'][4].token }));
              localStorage.setItem('otb_id', user.data[4].otb_id ? user.data[4].otb_id : '');
              localStorage.setItem('mf_token', user.data[5].mf_token ? user.data[5].mf_token : '');
              localStorage.setItem('is_bridge_course', user['data'][4].is_bridge_course);
              localStorage.setItem('enbsb', user['data'][4].is_only_bridgecourse);
              localStorage.setItem('enlni', user['data'][4].is_alumni);
              localStorage.setItem('islogged_cpa', '1');
              localStorage.setItem("reloadFromModel", "0");
              localStorage.setItem("showUSPathwayGuide", "true");
              // localStorage.setItem('subjectId', 'c53f9b7df8fbb22dc12d0e859a5c9734');
              const is_alumni = user.data[4].is_alumni;
              const token = user.data[4].token;
              this.getUsers(user.data[4].otb_id + '').then(result => {
                // this.store.dispatch(new Login({ authToken: user['data'][4].token }));
                if (result.payload.data()) {
                  // console.log('iff111');
                  this.is_clicked = false
                  Swal.fire({
                    html: `<p>Your account is logged in to another browser or your previous session was not
                    logged out properly.<br>Do you want to force login to your account?</p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#06345b',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                  }).then((result) => {
                    // console.log('then---');
                    if (result.value) {
                      // console.log('then iff');
                      this.firestore.collection('isLoggedIn').doc(user.data[4].otb_id + '').set({ token });
                      if (is_alumni == 1) {
                        this.is_clicked = false
                        this.router.navigateByUrl('/lms/mac');
                      } else {
                        this.is_clicked = false
                        // this.router.navigateByUrl('/lms/launchpad');
                        if (user.data && user.data[4].is_only_aicpa_inter) {
                          this.router.navigateByUrl('lms/cpa-inter');
                        } else {
                          this.router.navigateByUrl('/lms/launchpad');
                        }
                      }
                    }
                  });
                } else {
                  // console.log('elseee1111');
                  this.store.dispatch(new Login({ authToken: user['data'][4].token }));
                  this.firestore.collection('isLoggedIn').doc(user.data[4].otb_id + '').set({ token });
                  if (is_alumni == 1) {
                    this.is_clicked = false
                    this.router.navigateByUrl('/lms/mac');
                  } else {
                    this.is_clicked = false
                    // console.log('user.data[4].is_only_aicpa_inter11', user.data[4]);
                    if (user.data && user.data[4].is_only_aicpa_inter) {
                      // console.log('is_only_aicpa_inter11');
                      this.router.navigateByUrl('lms/cpa-inter');
                    } else {
                      // console.log('else is_only_aicpa_inter11');
                      // this.checkWelcomeScreen()
                      this.router.navigateByUrl('/lms/launchpad');
                    }
                  }
                }
              });
            } else if (user.data[4].int_user_status === 0) {
              this.is_clicked = false
              Swal.fire({
                text: 'Your account is under confirmation. Kindly connect with your Student Relationship Manager.',
                icon: 'warning'
              });
            } else if (user.data[4].int_user_status === 2) {
              this.is_clicked = false
              Swal.fire({
                text: 'Your access is blocked! Kindly connect with your Student Relationship Manager.',
                icon: 'error'
              });
            } else if (user.data[4].int_user_status === 3) {
              this.is_clicked = false
              Swal.fire({
                text: '',
                html: "Our records indicate that you have defaulted on your EMIs.</br>LMS access will remain blocked until the defaulted EMIs are paid!</br>Defaulting on EMIs will adversely impact your CIBIL score!",
                icon: 'error'
              });
            }
          } else {
            this.is_clicked = false
            this.errorMessage = user.message;
          }
        }),

      ).subscribe();
  }

  // checkWelcomeScreen() {
  //   this.gamePlanService.getStudentTotalDetails().subscribe((res: any) => {
  //     if (res && res.status) {
  //       this.userData = res.data[0]
  //       this.isWelcome = this.userData?.is_welcome === null ? 1 : this.userData?.is_welcome

  //       if (this.isWelcome == 1) {
  //         this.router.navigateByUrl('/godfather-start-page');
  //       }
  //       else if (this.isWelcome > 1 && this.isWelcome < 5) {
  //         this.router.navigateByUrl('/game-plan-status-page');
  //       } else if (this.isWelcome == 5) {
  //         this.router.navigateByUrl('/godfather-last-page');
  //       }
  //       else {
  //         // Code changed by Ganesh
  //         this.gamePlanService.updateUserPrioritizeSubject().subscribe((res: any) => {
  //           if (res && res.status) {
  //             localStorage.setItem('subjectId', res.data);
  //             this.router.navigateByUrl('/lms/launchpad');
  //           }
  //         })

  //       }

  //     }
  //   })
  // }

  logincma() {
    this.authService.login(this.loginForm.value.registration_id.trim(), this.loginForm.value.password.trim())
      .pipe(

        tap((user: any) => {
          this.loginForm.reset();
          if (user.status) {
            if (user.data[0].int_user_status === 1) {
              this.dbService.addTokenToIndexBd(user.data[0].token);
              this.dbService.addDataToIndexBd(user.data);
              localStorage.setItem('islogged_cma', '1');
              const token = user['data'][0].token;
              this.getUserscma(user['data'][0].sid).then(result => {
                // console.log('promise', result.payload.data());
                if (result.payload.data()) {
                  this.is_clicked = false
                  Swal.fire({
                    // title: 'Are you sure?',

                    html: `<p>Your account is logged in to another browser or your previous session was not
                  logged out properly.<br>Do you want to force login to your account?</p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#06345b',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                  }).then((result) => {
                    if (result.value) {
                      this.is_clicked = false
                      this.firestore.collection('isLoggedIn_CMA').doc(user['data'][0].sid + '').set({ token });
                      this.router.navigateByUrl('/cma/lms/launchpad');
                    }
                  });
                } else {
                  this.is_clicked = false
                  this.firestore.collection('isLoggedIn_CMA').doc(user['data'][0].sid + '').set({ token });
                  this.router.navigateByUrl('/cma/lms/launchpad');
                }
              });
              // this.router.navigateByUrl(['/cma/lms/launchpad']);
            } else if (user.data[0].int_user_status === 0) {
              this.is_clicked = false
              Swal.fire({
                text: 'Your account is under confirmation. Please contact Miles center manager',
                icon: 'warning'
              });
            } else if (user.data[0].int_user_status === 2) {
              this.is_clicked = false
              Swal.fire({
                text: 'Your access is blocked! Kindly connect with your Student Relationship Manager.',
                icon: 'error'
              });
            } else if (user.data[0].int_user_status === 3) {
              // this.is_clicked = false
              // localStorage.setItem('islogged_cma', '1');
              // this.dbService.addTokenToIndexBd(user.data[0].token);
              // this.router.navigateByUrl('/cma/lms/launchpad');
              this.is_clicked = false
              Swal.fire({
                text: '',
                html: "Our records indicate that you have defaulted on your EMIs.</br>LMS access will remain blocked until the defaulted EMIs are paid!</br>Defaulting on EMIs will adversely impact your CIBIL score!",
                icon: 'error'
              });
            }
          } else {
            this.is_clicked = false
            this.errorMessage = user.message;
          }
        }),
      ).subscribe();
  }


  handleReset() { }

  handleExpire() { }

  handleLoad() { }

  handleSuccess(event) { }

}
